import React from 'react';

import TalkToFishingImage from './assets/talkToFishes.svg';
import { DisplayTemplate } from './display-results-template';

export const TalkToFishingTemplate = () => {
  return (
    <DisplayTemplate
      image={TalkToFishingImage}
      title="You haven't texted anyone yet"
      subtitle={'Click on the available tab to see whether you have avilable fishes to contact with'}
    />
  );
};